import { QuestionnaireState } from '@/types/store'
import useVuex from '@/utils/useVuex'
import { reactive, SetupContext } from '@vue/composition-api'

export const useQuestionnaireLoading = (context: SetupContext) => {
  const store = context.root.$store
  const state = reactive({
    isLoading: useVuex<QuestionnaireState['isQuestionnaireLoading']>(
      context,
      () => store.getters['questionnaire/isQuestionnaireLoading'],
    ),
  })

  return { ...state }
}
